//For all routes defined here, Sidebar would be hidden and pages will be publicly accessed
export const unprotectedPages = ['/login', '/welcome', '/forgot_password', '/onboarding']
